import { render, staticRenderFns } from "./ManuallyForm.vue?vue&type=template&id=70c576e7&scoped=true&"
import script from "./ManuallyForm.vue?vue&type=script&lang=js&"
export * from "./ManuallyForm.vue?vue&type=script&lang=js&"
import style0 from "./ManuallyForm.vue?vue&type=style&index=0&id=70c576e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c576e7",
  null
  
)

export default component.exports